import React from 'react';
import {
  Button,
  makeStyles,
  createStyles,
  Theme,
  Divider,
} from '@material-ui/core';
import { BANNER_HEIGHT } from 'src/constants/uiConsts';
import { PLAN_PAGE } from 'src/constants';
import { ForwardIcon } from 'src/legacy/components/Icons';
import { BannerOptions } from 'src/store/ui/types';
import * as Colors from 'src/theme/colors';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { useSettingsPageRedirection } from 'src/legacy/components/Settings/useSettingsPageRedirection';
import { useDrawerWidth } from 'src/features/drawer/useDrawerWidth';

const useStyles = makeStyles<Theme, { drawerWidth: number }>((theme) =>
  createStyles({
    root: (props) => ({
      display: 'flex',
      justifyContent: 'center',
      minHeight: `${BANNER_HEIGHT}px`,
      height: `${BANNER_HEIGHT}px`,
      backgroundColor: Colors.CopilotDarkGreen,
      color: Colors.CopilotLightGreen,
      [theme.breakpoints.up('md')]: {
        marginLeft: `-${props.drawerWidth}px`,
      },
    }),
    conatiner: {
      display: 'flex',
      alignItems: 'center',
    },
    bannerButton: {
      color: Colors.CopilotLightGreen,
      '&:hover': {
        color: Colors.white,
        backgroundColor: 'transparent',
      },
    },
    divider: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      height: 20,
      backgroundColor: Colors.CopilotLightGreen,
    },
  }),
);

export const Banner: React.FC<BannerOptions> = ({ message, buttonOptions }) => {
  const drawerWidth = useDrawerWidth();
  const classes = useStyles({ drawerWidth });
  const { goToSettings: goToPlanSettingsPage } = useSettingsPageRedirection(
    true,
    PLAN_PAGE.path,
  );
  const handleClick = () => {
    if (buttonOptions) {
      goToPlanSettingsPage();
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.conatiner}>
        <BaseTypography fontType="13Medium">{message}</BaseTypography>
        <Divider
          orientation="vertical"
          variant="middle"
          className={classes.divider}
        />
        {buttonOptions ? (
          <Button
            variant="text"
            color="secondary"
            className={classes.bannerButton}
            onClick={handleClick}
            endIcon={<ForwardIcon />}
          >
            <BaseTypography fontType="13Medium">
              {buttonOptions.label}
            </BaseTypography>
          </Button>
        ) : null}
      </div>
    </div>
  );
};
